import React from "react";

export default function QuickStart() {
    return (
        <div className="">
            <div className="">
                <div className="bg-white rounded-xl shadow-lg overflow-hidden mt-[32px]">
                    <div className="px-8 py-10">
                        {/* Header */}
                        {/* <div className="bg-white rounded-lg shadow-sm p-8 mb-8"> */}
                            <div className="text-left">
                                <h1 className="text-2xl font-bold text-gray-900 mb-6">
                                    Platform Connection Guide
                                </h1>
                                <p className="text-lg text-gray-600 mx-auto mb-8">
                                    Connect Facebook, Instagram, WhatsApp, and Telegram to ChatInject to start managing all your social media conversations in one place.
                                </p>
                            </div>
                        {/* </div> */}

                        {/* Introduction Card */}
                        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8">
                            <h2 className="text-xl font-semibold text-blue-900 mb-3">
                                Getting Started
                            </h2>
                            <p className="text-blue-800 leading-relaxed">
                                Once you have successfully logged in to ChatInject, the next step is to link at least one platform (Facebook, Instagram, WhatsApp, or Telegram) to start using the features of the platform.
                            </p>
                        </div>

                        {/* Platform Selection */}
                        <div className="mb-10">
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">
                                Select a Platform to Link
                            </h2>
                            <p className="text-gray-600 mb-6">
                                Choose from Facebook, Instagram, WhatsApp, or Telegram based on your business needs. Each platform has a straightforward step-by-step connection process.
                            </p>

                            {/* Platform Cards */}
                            {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
                                {['Facebook', 'Instagram', 'WhatsApp', 'Telegram'].map((platform) => (
                                    <div key={platform} className="bg-gradient-to-br from-blue-500 to-purple-600 text-white rounded-lg p-4 text-center">
                                        <h3 className="font-semibold text-lg">{platform}</h3>
                                    </div>
                                ))}
                            </div> */}
                        </div>

                        {/* Facebook Connection */}
                        <div className="mb-12">
                            <div className="flex items-center mb-6">
                                <div className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3">
                                    <span className="font-bold">1</span>
                                </div>
                                <h2 className="text-2xl font-bold text-gray-900">Connecting Facebook</h2>
                            </div>

                            <div className="bg-gray-50 rounded-lg p-6 mb-6">
                                <h3 className="text-lg font-semibold text-gray-900 mb-4">Before You Begin</h3>
                                <p className="text-gray-700 mb-4">Ensure you have the following ready before starting:</p>

                                <div className="space-y-4">
                                    <div className="flex items-start">
                                        <div className="bg-blue-100 rounded-full p-1 mr-3 mt-1">
                                            <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                                        </div>
                                        <div>
                                            <h4 className="font-semibold text-gray-900">Facebook Account & Page</h4>
                                            <p className="text-gray-600">Make sure you have a Facebook account and a Facebook Page created for your business.</p>
                                        </div>
                                    </div>

                                    <div className="flex items-start">
                                        <div className="bg-blue-100 rounded-full p-1 mr-3 mt-1">
                                            <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                                        </div>
                                        <div>
                                            <h4 className="font-semibold text-gray-900">Social Media Platform Login Credentials</h4>
                                            <p className="text-gray-600">Have your login credentials for your social media platform ready.</p>
                                        </div>
                                    </div>

                                    <div className="flex items-start">
                                        <div className="bg-blue-100 rounded-full p-1 mr-3 mt-1">
                                            <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                                        </div>
                                        <div>
                                            <h4 className="font-semibold text-gray-900">Log in to Facebook</h4>
                                            <p className="text-gray-600">
                                                Open a web browser and navigate to{' '}
                                                <a href="https://www.facebook.com/" target="_blank" rel="noreferrer" className="text-blue-600 hover:text-blue-800 underline">
                                                    https://www.facebook.com/
                                                </a>
                                                , then log in using your Facebook account credentials.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="flex items-start">
                                        <div className="bg-blue-100 rounded-full p-1 mr-3 mt-1">
                                            <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                                        </div>
                                        <div>
                                            <h4 className="font-semibold text-gray-900">Access "Pages" Section</h4>
                                            <p className="text-gray-600">Locate and click on the "Pages" section within your Facebook interface. You might find it on the left-hand side menu or on your profile page.</p>
                                        </div>
                                    </div>

                                    <div className="flex items-start">
                                        <div className="bg-blue-100 rounded-full p-1 mr-3 mt-1">
                                            <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                                        </div>
                                        <div>
                                            <h4 className="font-semibold text-gray-900">Create a Facebook Page (if not done)</h4>
                                            <p className="text-gray-600">
                                                If you haven't created a Facebook Page yet, click on "Create New Page" and follow the on-screen prompts to set it up.{' '}
                                                <a href="https://www.facebook.com/business/help/268860861184453" target="_blank" rel="noreferrer" className="text-blue-600 hover:text-blue-800 underline">
                                                    Here's an example video for reference
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="bg-white border border-gray-200 rounded-lg p-6">
                                <h3 className="text-lg font-semibold text-gray-900 mb-4">Connection Steps</h3>
                                <div className="space-y-4">
                                    <div className="flex items-start">
                                        <span className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold mr-3 mt-1">1</span>
                                        <div>
                                            <h4 className="font-semibold text-gray-900">Log in to Your Social Media Platform</h4>
                                            <p className="text-gray-600">Open your chosen social media platform's website or app and log in using your account credentials.</p>
                                        </div>
                                    </div>

                                    <div className="flex items-start">
                                        <span className="bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold mr-3 mt-1">2</span>
                                        <div>
                                            <h4 className="font-semibold text-gray-900">Connect Your Facebook Page</h4>
                                            <p className="text-gray-600">
                                                Once logged in, navigate to the Dashboard and click on your profile icon or avatar within your social media platform.
                                                Select Settings. Look for a section related to social media connections or integrations.
                                                Choose Facebook and follow the prompts to log in to your Facebook account.
                                                Once logged in, authorize the connection between your Facebook page and your social media platform.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Instagram Connection */}
                        <div className="mb-12">
                            <div className="flex items-center mb-6">
                                <div className="bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3">
                                    <span className="font-bold">2</span>
                                </div>
                                <h2 className="text-2xl font-bold text-gray-900">Connecting Instagram</h2>
                            </div>

                            <div className="bg-gradient-to-r from-purple-50 to-pink-50 border border-purple-200 rounded-lg p-6 mb-6">
                                <div className="flex items-start">
                                    <div className="bg-amber-100 rounded-full p-1 mr-3 mt-1">
                                        <div className="w-3 h-3 bg-amber-500 rounded-full"></div>
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-semibold text-amber-800 mb-2">Important</h3>
                                        <p className="text-purple-800">Before connecting Instagram, you need to create an Instagram account (if not done).</p>
                                    </div>
                                </div>
                            </div>

                            <div className="bg-white border border-gray-200 rounded-lg p-6 mb-6">
                                <h3 className="text-lg font-semibold text-gray-900 mb-4">Setup Requirements</h3>
                                <p className="text-gray-700">
                                    To manage Instagram messages via SocialChat, Instagram business accounts must enable the connected tools to toggle under message control settings.
                                </p>
                            </div>

                            <div className="bg-gray-50 rounded-lg p-6">
                                <h3 className="text-lg font-semibold text-gray-900 mb-4">Connecting Instagram Account</h3>
                                <p className="text-gray-700 mb-4">
                                    Connect your Instagram Professional account to SocialChat. Click on Profile → Settings → Click on Social Media Connections & connect with Instagram.
                                </p>

                                <div className="bg-white border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
                                    <div className="text-gray-400 mb-2">
                                        <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                        </svg>
                                    </div>
                                    <p className="text-gray-500">Settings screenshot would appear here</p>
                                </div>
                            </div>
                        </div>

                        {/* WhatsApp Connection */}
                        <div className="mb-12">
                            <div className="flex items-center mb-6">
                                <div className="bg-green-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3">
                                    <span className="font-bold">3</span>
                                </div>
                                <h2 className="text-2xl font-bold text-gray-900">Connecting WhatsApp</h2>
                            </div>

                            <div className="bg-green-50 border border-green-200 rounded-lg p-6 mb-6">
                                <h3 className="text-lg font-semibold text-green-900 mb-4">Connection Process</h3>
                                <p className="text-green-800 mb-4">
                                    To connect WhatsApp to your ChatInject dashboard, log in to your ChatInject account, navigate to the Settings tab and click "WhatsApp". You will then need to select "Use your number" and follow the steps to verify your phone number with your Meta Business Account.
                                </p>

                                <div className="bg-white rounded-lg p-4">
                                    <h4 className="font-semibold text-gray-900 mb-2">Key Points to Remember:</h4>
                                    <div className="flex items-start">
                                        <span className="bg-green-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold mr-3 mt-1">✓</span>
                                        <div>
                                            <h5 className="font-semibold text-gray-900">Connect Your WhatsApp Account</h5>
                                            <p className="text-gray-600">Find the settings or integrations section within your social media platform and look for the option to connect your WhatsApp account.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Success Message */}
                        <div className="bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-lg p-8 text-center">
                            <div className="flex items-center justify-center mb-4">
                                <div className="bg-white bg-opacity-20 rounded-full p-3">
                                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                </div>
                            </div>
                            <h3 className="text-xl font-bold mb-2">You're All Set!</h3>
                            <p className="text-green-100">
                                After completing the above steps, your Facebook, Instagram, WhatsApp, and Telegram will be connected,
                                and you can manage interactions directly through your social media platform.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}